/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */


import React, { useEffect, useRef, useState } from "react";
import {
  AboutDiv,
  InformationContainer,
  InformationDiv,
  InformationHeading,
  MainContainer,
  ProfileDiv,
} from "../../components/Profile/Profile.style";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MedicalInformationIcon from "@mui/icons-material/MedicalInformation";

import { useSelector } from "react-redux";
import {
  EmptyDiv,
  HistoryTable,
  InputContainer,
  InputLevel,
  PdfDiv,
  PidDiv,
  RegHeadingDiv,
  RegisterDiv,
  TableHeadCell,
  TableHeadTr,
} from "../../components/Volunteer/Volunteer.style";
import profile from "../../Images/profile.png";
import girl from "../../Images/girl.png";
import HomeIcon from "@mui/icons-material/Home";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import AttachmentIcon from "@mui/icons-material/Attachment";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";

import moment from "moment/moment";
import { Button, TableCell } from "@mui/material";
import { BsFillPrinterFill } from "react-icons/bs";
// import PdfVolProfile from "./PdfVolProfile";

const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const currentDate = new Date();

  let ageYears = currentDate.getFullYear() - birthDate.getFullYear();
  let ageMonths = currentDate.getMonth() - birthDate.getMonth();
  let ageDays = currentDate.getDate() - birthDate.getDate();
  // const handlePrint = () => {
  //   const link = document.createElement('link');
  //   link.rel = 'stylesheet';
  //   link.type = 'text/css';
  //   link.href = 'print.css';
  //   document.getElementsByTagName('head')[0].appendChild(link);
  //   window.print();
  // };
  if (ageDays < 0) {
    const lastMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - 1,
      birthDate.getDate()
    );
    ageMonths = currentDate.getMonth() - lastMonth.getMonth();
    ageDays = currentDate.getDate() - lastMonth.getDate();
  }

  let ageString = "";

  if (ageYears > 0) {
    ageString += `${ageYears} ${
      ageYears === 0 || ageYears === 1 ? "Year" : "Years"
    }`;
  }

  // if (ageMonths > 0) {
  //   if (ageString) {
  //     ageString += `, ${ageMonths} ${ageMonths === 1 ? "Month" : "Months"}`;
  //   } else {
  //     ageString = `${ageMonths} ${ageMonths === 1 ? "Month" : "Months"}`;
  //   }
  // }

  // if (ageDays >= 0) {
  //   if (ageString) {
  //     ageString += `, ${ageDays} ${
  //       ageDays === 0 || ageDays === 1 ? "Day" : "Days"
  //     }`;
  //   } else {
  //     ageString = `${ageDays} ${
  //       ageDays === 0 || ageDays === 1 ? "Day" : "Days"
  //     }`;
  //   }
  // }

  return ageString;
};

const TrialVolunteerProfile = () => {
  const volunteerData = useSelector((state) => state.Modal.val);

  const femaleStatus = volunteerData?.sex;

  // ======== history api ========
  // useEffect(() => {
  //   const getHistory = async () => {
  //     const resHistory = await fetch(
  //       `${process.env.REACT_APP_API_URL}/api/voluntaryHistoryList/${volunteerData.vol_no}`
  //     );
  //     const resHis = await resHistory.json();
  //     setHistory(await resHis);
  //   };
  //   getHistory();
  // }, []);

  // useEffect(() => {}, [inputs]);

  return (
    <>
      <ProfileDiv>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "4fr 2fr",
            gap: "1rem",
          }}
        >
          {/* ========== volunteer profile image start ========= */}
          {femaleStatus === "Female" && (
            <div style={{ marginLeft: "1rem", marginTop: "1rem" }}>
              <img
                style={{
                  height: "125px",
                  wight: "auto",
                }}
                src={volunteerData.voluntary_image || girl}
                alt=""
              />
            </div>
          )}

          {femaleStatus === "Male" && (
            <div style={{ marginLeft: "1rem", marginTop: "1rem" }}>
              <img
                style={{
                  height: "125px",
                  wight: "auto",
                }}
                src={volunteerData.voluntary_image || profile}
                alt=""
              />
            </div>
          )}

          {femaleStatus === "Others" && (
            <div style={{ marginLeft: "1rem", marginTop: "1rem" }}>
              <img
                style={{
                  height: "125px",
                  wight: "auto",
                }}
                src={volunteerData.voluntary_image || profile}
                alt=""
              />
            </div>
          )}
          {/* ========== volunteer profile image end ========= */}
        </div>

        <AboutDiv className="entries" style={{ margin: " 1rem" }}>
          <AccountCircleIcon></AccountCircleIcon>
          <span
            style={{
              // color: "#1a202c",
              color: "#20215c",
              fontWeight: "600",
              letterSpacing: "0.4px",
              lineHeight: "32px",
              margin: "0px 0px 0px 8px",
            }}
          >
            About
          </span>
        </AboutDiv>

        <MainContainer>
          {/* ========= name ========== */}
          <InformationContainer>
            <InformationHeading>Name:</InformationHeading>
            <InformationDiv>{volunteerData?.full_name}</InformationDiv>
          </InformationContainer>

          {/* ============= sponser name ========== */}
          <InformationContainer>
            <InformationHeading>Sponser Name:</InformationHeading>
            <InformationDiv>{volunteerData?.sponsor_name}</InformationDiv>
          </InformationContainer>

          {/* ===== Study name ======= */}
          <InformationContainer>
            <InformationHeading>Study Name: </InformationHeading>
            <InformationDiv>{volunteerData?.study_name}</InformationDiv>
          </InformationContainer>

          {/* ======= trial name ======== */}
          <InformationContainer>
            <InformationHeading>Trial Name: </InformationHeading>
            <InformationDiv>{volunteerData?.trial_name}</InformationDiv>
          </InformationContainer>
        </MainContainer>

        {/* ========== History table ========== */}
        {/* {volunteerData.approved_status == 1 && ( */}
        <>
          <AboutDiv style={{ margin: " 1rem" }}>
            <HistoryEduIcon></HistoryEduIcon>
            <span
              style={{
                color: "#20215c",
                fontWeight: "600",
                letterSpacing: "0.4px",
                lineHeight: "32px",
                margin: "0px 0px 0px 8px",
              }}
            >
              History
            </span>
          </AboutDiv>

          {/* <VolunteerHeading>History List</VolunteerHeading> */}
          <HistoryTable style={{ width: "95%", marginLeft: "1rem" }}>
            <thead
              style={{
                color: "#ffffff",
                // margin: "2rem",
              }}
            ></thead>
            <TableHeadTr>
              <TableHeadCell>SL No.</TableHeadCell>
              <TableHeadCell>Study Code</TableHeadCell>
              <TableHeadCell>Date of Last IMP Intake</TableHeadCell>
              <TableHeadCell>Remarks</TableHeadCell>
            </TableHeadTr>

            {volunteerData?.history.map((history, index) => {
              return (
                <tbody key={index + 1}>
                  <tr
                    style={{
                      borderSpacing: 0,
                    }}
                  >
                    <TableCell
                      size="small"
                      style={
                        {
                          // textAlign: "center",
                          // padding: ".2rem",
                        }
                      }
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell size="small">{history.study_code}</TableCell>
                    <TableCell size="small">
                      {moment(history.complet_date).format("DD MMM YYYY")}
                    </TableCell>
                    <TableCell size="small">{history.remarks}</TableCell>
                  </tr>
                </tbody>
              );
            })}
          </HistoryTable>
        </>
        {/* )} */}
      </ProfileDiv>
      {/* <PDFViewer>
      <PdfVolProfile volunteerData={volunteerData} history={history} />
  </PDFViewer> */}
      {/* <PdfDiv>
        <PdfVolProfile volunteerData={volunteerData} history={history} />
      </PdfDiv> */}
    </>
  );
};

export default TrialVolunteerProfile;
